<div class="card shadow-sm">
  <div class="card-body">
    <div class="row">
      <div class="col">
        <h4 class="mb-3">{{ header }}</h4>
      </div>
    </div>

    <div class="row">
      <div class="col" [tds-data-loader]="{ key: 'user-assets', size: 'lg', class: 'm-2' }">
        <ng-container *ngIf="user_assets && user_assets.length > 0; else noAssets">
          <div *ngIf="no_asset_alert" class="row">
            <div class="col">
              <ngb-alert role="alert" class="show" [type]="'primary'" [dismissible]="false">
                <span>
                  {{ no_asset_alert }}
                </span>
              </ngb-alert>
            </div>
          </div>
          <div class="d-flex flex-column gap-3">
            <div
              as-button
              *ngFor="let asset of user_assets"
              class="card position-relative overflow-hidden elevate-white asset-card"
              [attr.aria-label]="assetAriaLabel(asset)"
              (click)="selectAsset(asset)"
            >
              <div
                *ngIf="asset.line && asset.line?.is_primary_contact"
                class="position-absolute top-0 start-0 asset-card__primary"
                aria-label="Primary line"
              >
                <span class="material-icons">verified</span>
              </div>
              <div
                *ngIf="isSelectedAsset(asset) && existing_asset?.asset_selection_case === 1"
                class="position-absolute top-0 start-100 text-end currently-in-cart"
              >
                <span ngbTooltip="{{ 'selected_item' | translate }}" class="material-icons">
                  check_circle
                </span>
              </div>

              <div class="card-body card-items card-items-md asset-card__details">
                <ts-asset-selection-item
                  class="d-contents"
                  [asset]="asset"
                  [asset_fields]="asset_fields"
                />
              </div>
              <div stop-click-propagation *ngIf="hasMultiSim(asset)" class="card-footer">
                <button
                  type="button"
                  class="d-flex justify-content-center btn text-capitalize fw-normal w-100"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#multiSimOffCanvas"
                  aria-controls="multiSimOffCanvas"
                  (click)="openAssetOffCanvas(multiSimOffCanvas, asset)"
                >
                  <span *ngIf="asset.multi_sim_type === multi_sim_types[0]">
                    <span class="material-icons lh-base">hub</span>&nbsp;
                    <span>
                      {{ 'additional_lines' | translate }}
                      ({{ asset.additional_lines?.length }})
                    </span>
                  </span>
                  <span
                    *ngIf="[multi_sim_types[1], multi_sim_types[6]].includes(asset.multi_sim_type)"
                  >
                    <span class="material-icons lh-base">hub</span>&nbsp;
                    <span>
                      {{ 'additional_devices' | translate }}
                      ({{ asset.additional_devices?.length }})
                    </span>
                  </span>
                </button>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>

    <ng-container [ngTemplateOutlet]="cardTemplate"></ng-container>
  </div>
</div>

<ng-template #noAssets>
  <ngb-alert *ngIf="!!user_assets" role="alert" class="show" [type]="'info'" [dismissible]="false">
    <span>{{ no_asset_text }}</span>
  </ngb-alert>
</ng-template>

<ng-template #multiSimOffCanvas let-offcanvas>
  <ts-multisim-offcanvas
    class="overflow-auto"
    [offcanvas_asset]="offcanvas_asset"
    [offcanvas]="offcanvas"
  ></ts-multisim-offcanvas>
</ng-template>
